import { KameleoonService } from './../../app/services/kameleoon.service';
import { google } from 'google-maps';
import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  HostListener,
  ViewChild,
} from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { CancelAsync } from './../../app/models/cancelAsync';
import { OffersService } from './../../app/services/offers.service';
import { PointsDeRendezVousService } from './../../app/services/points-de-rendez-vous.service';

import { ModalIframeComponent, ModalMarketingComponent } from '@app/modals';
import { ModalController, Platform } from '@ionic/angular';

import {
  AppInitService,
  NavigationService,
  NetworkStatusService,
  PageLoaderService,
  StatsService,
  StorageService,
  StudentService,
} from '@app/services';
import * as moment from 'moment-timezone';

import { Student, StudentPurshasesDetails } from '@app/models';

import { UtilsService } from '@commons/services';

import { environment } from '@app/env';
import { EasyDebugDecorator } from '../../app/decorators/easy-debug.decorator';
import { PricesFormater } from '../../commons/pipes/prices.pipe';
import { TunnelPaiementStepsEnum } from '../tunnel-paiement-refonte/enums/tunnel-paiement-steps.enum';

@EasyDebugDecorator
@Component({
  selector: 'offres-page',
  templateUrl: 'offres.page.html',
  styleUrls: ['offres.page.scss'],
})
export class OffresPage extends CancelAsync {
  @ViewChild('modalExamConduite') modalExamConduite: any;
  @ViewChild('modalOfferNotFound') modalOfferNotFound: any;

  tunnelPaiementUrl = 'tunnel-paiement';
  pageTitle = 'Offres';
  activeLink = 'offres';

  iconPath = './uikit-assets/icons/orion-svg-sprite.svg#';

  initPageDone = false;
  statsSent = false;

  isDesktop = window.innerWidth > 767;
  isCordova = false;

  blocHeaderTitle = 'Nos offres';
  blocHeaderBackUrl = 'conduite';

  student: Student;
  userLifeCycle: any;

  longLoading = false;
  pageStart = Date.now();
  checkPageLoadingTimeInterval: any;

  cerfaStatus: any;
  noCerfa = true;
  isCerfaValid = false;
  cerfaDone = false;

  pricesFormater = new PricesFormater();

  // PAYMENTS GIFTS OFFERS
  studentPurshases: StudentPurshasesDetails;
  payments = [];
  gifts = [];
  coupons = [];
  paymentsGiftsCoupons: any = [];
  offers: any = [];
  studentCustomOffers: any = [];
  fetchOffersFailed = false;
  fetchStudentCustomOffersFailed = false;
  isPackPermis = false;
  isPackCode = false;
  isPackCodePremium = false;
  isHourOnly = false;
  hasHours = false;
  paymentsDone = false;

  cardWhichOfferVideo = {
    title: 'Quelle offre est faite pour moi ?',
    description: '',
    text: '',
    amount: null,
    delPrice: '',
    badge: '',
    link: 'which-offer',
    promo: false,
    forceWidth100: true,
    invert: true,
  };
  cardCPF = {
    title: 'Financement CPF',
    description: 'Passez le permis pour 100€ à peine',
    text: '',
    amount: null,
    delPrice: '',
    badge: '',
    link: 'cpf',
    promo: false,
    forceWidth100: true,
    invert: true,
  };

  callCenterPhone = '0800 0200 0200';
  callCenterPhoneFormatted = '080002000200';

  builtOfferCards = [];
  switchOffers = 'BVM';

  codeTitle = 'Code de la route';
  drivingTitle = 'Leçons de conduite';
  drivingSubTitle = 'à partir de 37€';
  recommendedTitle = 'Recommandé';

  cardsDone = false;

  displayModalOfferNotFound = false;
  modalShown = false;

  showEmbedElt = false;
  embedSrc = null;

  stepChangeSub: any;
  pageLoaderSteps = [
    'init0',
    'init1',
    'init2',
    'init3',
    'init4',
    'init5',
    'initPage',
  ];
  hasMadeInit = false;
  postalCode = null;

  showModalMap = false;
  placeLocationsSent = false;
  map: any;
  mapLoading = false;
  franceLocation = { lat: 46.927638, lng: 1.713749 };
  userInput = '';
  userAddress = '';
  userPostalCode = '';
  userNearestLocation = '';
  isLocationFar = false;
  bounds = new google.maps.LatLngBounds();
  boundsPoints = [];

  autocomplete: any;
  lastZoom = null;
  zoomOptionsUpdated = false;
  geocoder: any;
  infoWindow: any;
  infoWindowShown = false;
  mapLoaded = false;
  queryLat: any;
  queryLng: any;
  markers = [];
  lastActiveMarker: any;
  showResultsFullCards = true;

  geolocationLoading = false;
  noGeolocText = '';
  modalNoGeoloc = false;
  skipGeoloc = false;
  geolocFounded = false;
  modalLocationError = false;
  modalSearchError = false;
  userIsTyping = false;

  hideCnil = true;

  modalNoResults = false;
  addressInvalid = false;

  userPosition = null;
  idfDepartement = ['75', '77', '78', '91', '92', '93', '94', '95'];
  pricingZone = null;
  zipCode = null;

  finalInitDone = false;

  @ViewChild('gMap', { static: false }) mapElement: ElementRef;

  @HostListener('window:resize', ['$event']) onResize(event) {
    this.isDesktop = window.innerWidth > 767;
  }

  constructor(
    public pageLoaderService: PageLoaderService,
    private readonly appInitService: AppInitService,
    private readonly studentService: StudentService,
    private readonly navigationService: NavigationService,
    public platform: Platform,
    private readonly modalController: ModalController,
    private readonly statsService: StatsService,
    public router: Router,
    public utils: UtilsService,
    public sanitizer: DomSanitizer,
    public networkStatusService: NetworkStatusService,
    public storageService: StorageService,
    private readonly cdr: ChangeDetectorRef,
    private readonly pointsDeRendezVousService: PointsDeRendezVousService,
    private readonly networkService: NetworkStatusService,
    private readonly offersService: OffersService,
    private readonly kameleoonService: KameleoonService
  ) {
    super({ cancel: false, subscription: null });

    this.checkPageLoadingTimeInterval = setInterval(() => {
      const now = Date.now();
      // 3 sec
      if (now - this.pageStart >= 3000) {
        this.longLoading = true;
        clearInterval(this.checkPageLoadingTimeInterval);
      }
    }, 200);

    if (!this.appInitService.done) {
      this.navigationService.timestamp = Date.now();
      this.navigationService.lastLink = this.router.url.substr(1);
      this.hasMadeInit = true;
    } else {
      this.hasMadeInit = false;
    }

    this.isCordova = this.platform.is('cordova');

    // BACK BUTTON
    console.log('Referer => ', document.referrer);
    if (document.referrer.startsWith(environment.cmsBase) && !this.isCordova) {
      this.blocHeaderBackUrl = 'home';
    } else {
      const getBackNavigation = this.navigationService.checkUserNavigation();
      if (!!getBackNavigation && !!getBackNavigation.url) {
        this.blocHeaderBackUrl = getBackNavigation.url;
      }
    }

    this.userLifeCycle = this.studentService.getUserLifeCycle(this.student); // if student not ready return guest
    if (this.appInitService.done) {
      this.pageLoaderSteps = ['initApp', 'initPage'];
      this.pageLoaderService.setSteps(
        this.pageLoaderSteps.indexOf('initApp') + 1,
        this.pageLoaderSteps.length
      );
    }
    this.stepChangeSub = this.appInitService.onStepChange().subscribe(state => {
      if (state?.init >= 3 && state?.stepDone && !this.initPageDone) {
        this.initPage();
      }
      if (state?.init && state?.stepDone && !this.initPageDone) {
        this.pageLoaderService.setSteps(
          state.init + 1,
          this.pageLoaderSteps.length
        );
      }
      if (state?.initDone && !this.finalInitDone) {
        this.finalInitDone = true;
        this.initPage();
      }
    });
  }

  ionViewWillLeave() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
    if (this.stepChangeSub) {
      this.stepChangeSub.unsubscribe();
    }
  }

  private async setCpfMessage() {
    const userProperties = await this.studentService.fetchUserProperties();
    if (!!userProperties && !!userProperties.errorCode) {
      return;
    }
    const { client_type: clientType } = userProperties;
    if (
      ['pack_permis', 'pack_cpf', 'hours', 'pack_hours'].includes(clientType)
    ) {
      this.cardCPF.description = 'Prends des heures complémentaires';
      this.cardCPF.link = 'infos-cpf';
    } else {
      this.cardCPF.description = 'Et si tu y avais droit ?';
      this.cardCPF.link = 'cpf';
    }
  }

  async initPage() {
    this.initPageDone = true;
    this.student = this.studentService.student;
    if (!this.student.isGuest()) {
      await this.setCpfMessage();
    }
    if (this.offersService.gearType) {
      if (this.offersService.gearType.err) {
        // FETCH BOITE DE VITESSE ERROR
      } else {
        this.switchOffers = this.offersService.gearType;
      }
    }
    if (
      !!this.student?.driving_department?.number &&
      !!this.student?.driving_department?.department &&
      !!this.student?.driving_department?.pricing_zone_id &&
      this.student?.near_bva_location != null
    ) {
      if (
        this.idfDepartement.indexOf(this.student.driving_department.number) > -1
      ) {
        this.pricingZone = `Île-de-France`;
      } else {
        this.pricingZone = this.student.driving_department.department;
      }
    } else if (!!this.student && this.student.isGuest()) {
      this.openModalMap();
    } else if (
      this.pricingZone === '' ||
      this.pricingZone === null ||
      this.pricingZone === undefined
    ) {
      this.openModalMap();
    }

    this.userLifeCycle = this.studentService.getUserLifeCycle(this.student);

    this.getPayments();

    if (!!this.student && !this.student.isGuest()) {
      const resGetStudentCustomOffers = await this.offersService
        .fetchStudentCustomOffers(this.student, 'all')
        .toPromise();
      if (
        !!resGetStudentCustomOffers &&
        !!resGetStudentCustomOffers.errorCode &&
        resGetStudentCustomOffers.errorCode === 'E301'
      ) {
        this.fetchStudentCustomOffersFailed = true;
      } else {
        this.studentCustomOffers = resGetStudentCustomOffers;
      }
    }

    this.buildOfferCards();

    this.pageLoaderService.setSteps(
      this.pageLoaderSteps.indexOf('initPage') + 1,
      this.pageLoaderSteps.length
    );
    setTimeout(() => {
      this.pageLoaderService.stepsDone();
    }, 300);
    // PAGE LOAD EVENT
    if (
      !!this.navigationService.timestamp &&
      !!this.navigationService.lastLink &&
      !this.statsSent
    ) {
      const statObj = {
        page: this.navigationService.lastLink,
        loadTime: Date.now() - this.navigationService.timestamp,
        withInit: this.hasMadeInit,
      };
      if (this.statsService.isDebug) {
        console.log(statObj);
      }
      this.statsService.send({ name: 'page:view', payload: statObj });
      this.statsSent = true;
    }
    const callCenterElement = document.getElementById('call-center-phone');
    this.callCenterPhone =
      !!callCenterElement && !!callCenterElement.innerHTML
        ? callCenterElement.innerHTML
        : '';
    this.callCenterPhoneFormatted =
      !!callCenterElement && !!callCenterElement.innerHTML
        ? callCenterElement.innerHTML.replaceAll(' ', '')
        : '';

    await this.storageService
      .get(`${this.student.remoteId}-OfflineLastLink`)
      .then(async link => {
        if (!!link && !!link.modalToOpenOnReload) {
          await this.storageService.remove(
            `${this.student.remoteId}-OfflineLastLink`
          );
          this.showEmbed(link.modalToOpenOnReload);
        }
      });
  }

  mapInitializer() {
    if (this.mapElement) {
      const zoomValue = window.innerWidth >= 768 ? 6 : 5;
      const styledMapType = new google.maps.StyledMapType(
        [
          {
            featureType: 'poi',
            elementType: 'labels',
            stylers: [{ visibility: 'off' }],
          },
        ],
        { name: 'Styled Map' }
      );

      this.map = new google.maps.Map(this.mapElement.nativeElement, {
        center: this.franceLocation,
        zoom: zoomValue,
        zoomControl: true,
        minZoom: 5,
        maxZoom: 18,
        zoomControlOptions: {
          position: google.maps.ControlPosition.RIGHT_TOP,
        },
        mapTypeControl: false,
        streetViewControl: false,
        fullscreenControl: false,
        mapTypeControlOptions: {
          mapTypeIds: ['roadmap', 'styled_map'],
        },
      });

      // Associate the styled map with the MapTypeId and set it to display.
      this.map.mapTypes.set('styled_map', styledMapType);
      this.map.setMapTypeId('styled_map');

      const options = {
        componentRestrictions: { country: 'fr' },
      };

      const input: any = document.getElementById('geoloc-input');
      this.userAddress = input.value;
      this.autocomplete = new google.maps.places.Autocomplete(input, options);

      google.maps.event.addListener(this.autocomplete, 'place_changed', e => {
        this.mapLoading = true;
        input.blur();
        this.hideToasterInvalidAddress();
        this.removeUserPositionMarker();
        this.resetMarker();
        this.resetActiveMarker();
        this.geoCoding();
      });

      google.maps.event.addListener(this.map, 'zoom_changed', () => {
        input.blur();
        this.lastZoom = this.map.getZoom();
      });

      window.addEventListener('wheel', (event: any) => {
        input.blur();
        if (!this.zoomOptionsUpdated) {
          this.map.setOptions({
            minZoom: 5,
            maxZoom: 18,
          });
          this.zoomOptionsUpdated = true;
        }
      });
      window.addEventListener('touchstart', (event: any) => {
        if (!this.zoomOptionsUpdated) {
          this.map.setOptions({
            minZoom: 5,
            maxZoom: 18,
          });
          this.zoomOptionsUpdated = true;
        }
      });

      this.geocoder = new google.maps.Geocoder();

      this.infoWindow = new google.maps.InfoWindow({
        content: '',
        disableAutoPan: true,
      });

      this.map.addListener('click', (event: any) => {
        input.blur();
        if (this.infoWindowShown) {
          this.infoWindow.close();
          this.infoWindowShown = false;
        }
      });

      this.map.addListener('dragstart', () => {
        input.blur();
        if (this.infoWindowShown) {
          this.infoWindow.close();
          this.infoWindowShown = false;
        }
      });

      google.maps.event.addListenerOnce(this.map, 'tilesloaded', () => {
        this.mapLoaded = true;
        if (!!this.queryLat && !!this.queryLng) {
        }
        this.cdr.detectChanges();
      });
    } else {
      const input: any = document.getElementById('geoloc-input');
      this.userAddress = input.value;
    }
  }

  resetActiveMarker() {
    this.updateMarker(true);
    this.infoWindow.close();
    this.infoWindowShown = false;
    this.cdr.detectChanges();
  }

  updateMarker(reset?: boolean) {
    if (reset) {
      for (let i = 0, len = this.markers.length; i < len; i++) {
        this.markers[i].setIcon(
          'https://app.envoituresimone.com/assets/png/pin-default.png'
        );
      }
    }
  }

  removeUserPositionMarker() {
    const markerUserLocation = this.markers.find(elt => elt.userPosition);
    const markerUserLocationIndex = this.markers.findIndex(
      elt => elt.userPosition
    );
    if (markerUserLocation) {
      google.maps.event.clearListeners(
        this.markers[markerUserLocationIndex],
        'click'
      );
      this.markers.splice(markerUserLocationIndex, 1);
      markerUserLocation.setMap(null);
    }
    this.infoWindow.close();
    this.infoWindowShown = false;
    this.cdr.detectChanges();
  }

  geoCoding() {
    this.geolocationLoading = false;
    this.placeLocationsSent = true;
    const address: any = document.getElementById('geoloc-input');
    this.userAddress = address.value;
    this.cdr.detectChanges();
    if (!!address && !!address.value && address.value !== '') {
      this.geocoder.geocode(
        { address: address.value },
        (results: any, status: any) => {
          if (status === 'OK') {
            this.hideToasterInvalidAddress();
            this.addMarker(
              {
                position: {
                  lat: results[0].geometry.location.lat(),
                  lng: results[0].geometry.location.lng(),
                },
              },
              false,
              true
            );
            this.userPosition = {
              lat: results[0].geometry.location.lat(),
              lng: results[0].geometry.location.lng(),
            };
            this.getAdress(
              results[0].geometry.location.lat(),
              results[0].geometry.location.lng()
            );
          } else {
            this.showToasterInvalidAddress();
            this.mapLoading = false;
          }
        }
      );
    }
  }

  async getAdress(lat: any, lng: any) {
    const input: any = document.getElementById('geoloc-input');
    this.userAddress = input.value;
    this.isLocationFar = false;
    const locationArray =
      await this.pointsDeRendezVousService.fetchNearestLocation(
        lat,
        lng,
        this.switchOffers
      );
    if (!!locationArray && !!locationArray.errorCode) {
      return;
    }
    const result = locationArray[0].attributes;
    if (!!result && !!result.more_15km_radius) {
      this.isLocationFar = true;
      if (!!result.name && !!result.zipcode) {
        this.userNearestLocation = `${result.city} (${result.zipcode})`;
      }
    }
    let pricingZone = null;
    if (
      !!result &&
      !!result.departement &&
      !!result.departement.number &&
      !!result.departement.department &&
      result.departement.pricing_zone_id
    ) {
      if (this.idfDepartement.indexOf(result.departement.number) > -1) {
        pricingZone = `Île-de-France`;
      } else {
        pricingZone = result.departement.department;
      }
    }
    this.addMarker(
      {
        position: { lat: result.latitude, lng: result.longitude },
        location: {
          name: result.name,
          zipcode: result.zipcode,
          pricingZone: pricingZone,
        },
      },
      true,
      false
    );
    for (let i = 0, len = locationArray.length; i < len; i++) {
      if (
        i > 0 &&
        !!locationArray[i]?.attributes?.name &&
        !!locationArray[i].attributes.zipcode
      ) {
        this.addMarker(
          {
            position: {
              lat: locationArray[i].attributes.latitude,
              lng: locationArray[i].attributes.longitude,
            },
            location: {
              name: locationArray[i].attributes.name,
              zipcode: locationArray[i].attributes.zipcode,
              pricingZone: pricingZone,
            },
          },
          false,
          false,
          true
        );
      }
    }
    this.mapLoading = false;
    this.cdr.detectChanges();
  }

  openModalMap() {
    this.showModalMap = true;
    setTimeout(() => {
      this.mapInitializer();
    }, 0);
  }

  closeModalMap(updated: boolean = false) {
    if (updated) {
      if (
        !!this.student?.driving_department?.number &&
        !!this.student?.driving_department?.department
      ) {
        if (
          this.idfDepartement.indexOf(this.student.driving_department.number) >
          -1
        ) {
          this.pricingZone = `Île-de-France`;
        } else {
          this.pricingZone = this.student.driving_department.department;
        }
        this.showModalMap = false;
      } else {
        this.showModalMap = false;
      }
    } else {
      this.showModalMap = false;
    }
    this.resetInput();
    this.removeUserPositionMarker();
  }

  resetInput() {
    this.isLocationFar = false;
    this.placeLocationsSent = false;
    this.geolocationLoading = false;
    this.userInput = '';
    this.userAddress = '';
    this.userIsTyping = false;
    const input: any = document.getElementById('geoloc-input');
    input.value = '';
  }

  resetMarker() {
    for (let i = 0, len = this.markers.length; i < len; i++) {
      this.markers[i].setMap(null);
    }
    this.markers = [];
  }

  async changeUserCP() {
    if (this.student.isGuest()) {
      const resOffers = await this.offersService
        .fetchOffers(this.zipCode)
        .toPromise();
      if (
        !!resOffers &&
        !!resOffers.errorCode &&
        resOffers.errorCode === 'E301'
      ) {
        alert('Erreur lors de la récupération des offres');
      } else {
        this.studentCustomOffers = resOffers;
        this.builtOfferCards = [];
        this.cardsDone = false;
        this.buildOfferCards();
        console.log(this.builtOfferCards);
      }
      this.closeModalMap();
    } else {
      await this.studentService.updateCP(this.zipCode);
      this.closeModalMap();
      this.initPageDone = false;
      this.cardsDone = false;
      this.builtOfferCards = [];
      this.appInitService.init0();
    }
  }

  addMarker(
    markerProperties: any,
    showInfowWindow = false,
    userPosition = false,
    unmarked = false
  ) {
    const markerSettings: any = {};
    markerSettings.position = markerProperties.position;
    markerSettings.animation = google.maps.Animation.DROP;
    if (userPosition) {
      markerSettings.icon =
        'https://app.envoituresimone.com/assets/png/pin-location.png';
    } else if (!unmarked) {
      if (this.switchOffers === 'BVA') {
        markerSettings.icon = 'assets/png/pin-active-auto.png';
      } else {
        markerSettings.icon =
          'https://app.envoituresimone.com/assets/png/pin-active.png';
      }
    } else {
      markerSettings.icon =
        'https://app.envoituresimone.com/assets/png/pin-default.png';
    }

    let markerTitle = '';
    if (userPosition) {
      markerTitle = 'Tu es ici';
    } else {
      markerTitle = markerProperties.location.name;
    }

    markerSettings.title = markerTitle;
    if (userPosition) {
      markerSettings.userPosition = true;
    }

    if (!userPosition) {
      this.cdr.detectChanges();
      if (!!markerProperties.location.pricingZone && !unmarked) {
        this.pricingZone = markerProperties.location.pricingZone;
        this.zipCode = markerProperties.location.zipcode;
      }
    }

    const marker: any = new google.maps.Marker(markerSettings);
    marker.setMap(this.map); // add to map

    if (!userPosition && showInfowWindow) {
      this.lastActiveMarker = marker;
    }

    // addlisteners
    marker.addListener('mouseover', () => {
      this.showInfoWindow(marker);
      if (!marker.userPosition) {
        marker.setAnimation(google.maps.Animation.BOUNCE);
      }
    });
    marker.addListener('mouseout', () => {
      marker.setAnimation(null);
      if (this.infoWindowShown) {
        this.infoWindow.close();
        this.infoWindowShown = false;
      }
    });
    marker.addListener('click', () => {
      const input: any = document.getElementById('geoloc-input');
      input.blur();
      const findMarker = this.markers.find(elt => elt === marker);

      if (findMarker === this.lastActiveMarker) {
        this.updateZoom();
        this.centerMap(marker.position.lat(), marker.position.lng());
      }
    });

    if (showInfowWindow) {
      this.centerMap(marker.position.lat(), marker.position.lng());
      this.showInfoWindow(marker);
    }
    this.markers.push(marker);
  }

  updateZoom() {
    if (this.map.getZoom() < this.lastZoom) {
      this.map.setZoom(this.lastZoom);
    }
  }

  centerMap(lat: any, lng: any) {
    this.newBounds();
    this.addToBounds(this.userPosition.lat, this.userPosition.lng);
    this.addToBounds(lat, lng);
    this.processBounds();
    this.fitBounds();
  }

  showInfoWindow(marker: any) {
    const contentString = marker.title;
    if (this.infoWindowShown) {
      this.infoWindow.close();
      this.infoWindowShown = false;
    }
    this.infoWindow = new google.maps.InfoWindow({
      content: contentString,
      disableAutoPan: true,
    });
    this.infoWindow.open(this.map, marker);
    this.infoWindowShown = true;
    this.cdr.detectChanges();
  }

  newBounds() {
    this.bounds = new google.maps.LatLngBounds();
    this.boundsPoints = [];
  }

  addToBounds(lat: any, lng: any) {
    this.boundsPoints.push(new google.maps.LatLng(lat, lng));
  }

  processBounds() {
    for (let i = 0, len = this.boundsPoints.length; i < len; i++) {
      this.bounds.extend(this.boundsPoints[i]);
    }
  }

  fitBounds() {
    if (this.boundsPoints.length === 1) {
      this.map.setOptions({
        minZoom: 11,
        maxZoom: this.map.getZoom() >= 11 ? this.map.getZoom() : 16,
      });
      this.zoomOptionsUpdated = false;
      this.lastZoom = this.map.getZoom() !== 14 ? this.map.getZoom() : 14;
    } else {
      this.map.setOptions({
        minZoom: 5,
        maxZoom: 18,
      });
      this.zoomOptionsUpdated = true;
    }
    const paddingBounds = 50;
    this.map.fitBounds(this.bounds, {
      bottom: paddingBounds,
      top: 75,
      left: paddingBounds,
      right: paddingBounds,
    });
  }

  cleanMap() {
    this.resetInput();
    this.removeUserPositionMarker();
    this.resetMarker();
    this.resetActiveMarker();
  }

  checkUserInputValue() {
    const input: any = document.getElementById('geoloc-input');
    input.placeholder = '';
    if (input) {
      this.userIsTyping = input.value.length > 0;
    }
  }

  showCurrentLocation() {
    if (!this.geolocationLoading) {
      this.skipGeoloc = false;
      this.geolocFounded = false;
      if (navigator.geolocation && 'geolocation' in navigator) {
        this.geolocationLoading = true;
        setTimeout(() => {
          this.geolocationLoading = false;
          if (!this.skipGeoloc && !this.geolocFounded) {
            this.skipGeoloc = true;
            this.geolocFounded = false;
            this.noGeolocText =
              'Nous ne sommes pas parvenus à récupérer ta position !';
            this.showModalNoGeoloc();
            this.cdr.detectChanges();
          }
        }, 5000);
        // ya un prob avec ce truc des fois il se lance mais ne fait rien d'autre ni confirmation ni erreur
        navigator.geolocation.getCurrentPosition(
          (position: any) => {
            this.geolocFounded = true;
            this.skipGeoloc = false;
            if (!this.skipGeoloc) {
              this.hideCnil = true;
              this.geolocationLoading = false;
              const pos = {
                lat: position.coords.latitude,
                lng: position.coords.longitude,
              };
              this.cdr.detectChanges();
              this.geocoder.geocode(
                { location: pos },
                (results: any, status: any) => {
                  if (status === 'OK') {
                    if (results[0]) {
                      if (results[0].formatted_address) {
                        const address: any =
                          document.getElementById('geoloc-input');
                        address.value = results[0].formatted_address;
                        this.placeLocationsSent = true;
                      }
                      this.geolocationLoading = false;
                      this.cdr.detectChanges();
                      this.addMarker(
                        {
                          position: {
                            lat: results[0].geometry.location.lat(),
                            lng: results[0].geometry.location.lng(),
                          },
                        },
                        false,
                        true
                      );
                      this.userPosition = {
                        lat: results[0].geometry.location.lat(),
                        lng: results[0].geometry.location.lng(),
                      };
                      this.getAdress(
                        results[0].geometry.location.lat(),
                        results[0].geometry.location.lng()
                      );
                    } else {
                      this.geolocationLoading = false;
                      this.skipGeoloc = true;
                      this.geolocFounded = false;
                      this.noGeolocText =
                        'Nous ne sommes pas parvenus à récupérer ta position !';
                      this.cdr.detectChanges();
                      this.showModalNoGeoloc();
                    }
                  } else {
                    this.geolocationLoading = false;
                    this.skipGeoloc = true;
                    this.geolocFounded = false;
                    this.noGeolocText =
                      'Nous ne sommes pas parvenus à récupérer ta position !';
                    this.cdr.detectChanges();
                    this.showModalNoGeoloc();
                  }
                }
              );
            }
          },
          () => {
            this.geolocationLoading = false;
            this.geolocFounded = false;
            this.cdr.detectChanges();
            if (!this.skipGeoloc) {
              this.skipGeoloc = true;
              this.noGeolocText =
                'Nous ne sommes pas parvenus à récupérer ta position !';
              this.cdr.detectChanges();
              this.showModalNoGeoloc();
            }
          }
        );
      } else {
        this.geolocationLoading = false;
        this.geolocFounded = false;
        this.cdr.detectChanges();
        if (!this.skipGeoloc) {
          this.noGeolocText =
            'Ton navigateur ne supporte pas la Geolocalisation!';
          this.cdr.detectChanges();
          this.showModalNoGeoloc();
        }
      }
    }
  }

  showToasterInvalidAddress() {
    this.addressInvalid = true;
    this.cdr.detectChanges();
    setTimeout(() => {
      this.hideToasterInvalidAddress();
      this.resetInput();
    }, 1000);
  }

  hideToasterInvalidAddress() {
    this.addressInvalid = false;
    this.cdr.detectChanges();
  }

  showModalNoResults() {
    this.modalNoResults = true;
    this.cdr.detectChanges();
  }

  hideModalNoResults() {
    this.modalNoResults = false;
    this.cdr.detectChanges();
    this.resetInput();
  }

  showModalNoGeoloc() {
    this.modalNoGeoloc = true;
    this.geolocationLoading = false;
    this.cdr.detectChanges();
  }

  hideModalNoGeoloc() {
    this.modalNoGeoloc = false;
    this.geolocationLoading = false;
    this.cdr.detectChanges();
  }

  showModalLocationError() {
    this.modalLocationError = true;
    this.geolocationLoading = false;
    this.cdr.detectChanges();
  }

  hideModalLocationError() {
    this.modalLocationError = false;
    this.geolocationLoading = false;
    this.cdr.detectChanges();
  }

  showModalSearchError() {
    this.modalSearchError = true;
    this.geolocationLoading = false;
    this.cdr.detectChanges();
  }

  hideModalSearchError() {
    this.modalSearchError = false;
    this.geolocationLoading = false;
    this.cdr.detectChanges();
  }

  getPayments() {
    this.studentPurshases = this.studentService.getStudentPurshases();

    const resGetOffers = this.studentPurshases.offers;
    if (
      !!resGetOffers &&
      !!resGetOffers.errorCode &&
      resGetOffers.errorCode === 'E301'
    ) {
      this.fetchOffersFailed = true;
    } else {
      this.offers = resGetOffers;
    }

    this.gifts = this.studentPurshases.gifts;
    this.studentPurshases.linkOfferTopayment();
    this.studentPurshases.removeCouponsIfPresentInPayments();
    this.payments = this.studentPurshases.payments;
    this.coupons = this.studentPurshases.coupons;

    this.hasHours = this.studentPurshases.hasHours();
    this.isHourOnly = this.studentPurshases.isHourOnly();
    this.isPackCode = this.studentPurshases.isPackCode();
    this.isPackCodePremium = this.studentPurshases.isPackCodePremium();
    this.isPackPermis = this.studentPurshases.isPackPermis();

    const tmp = this.gifts.concat(this.coupons);
    this.paymentsGiftsCoupons = tmp.concat(this.payments);

    this.paymentsDone = true;
  }

  dateToFormatFr(input?: any) {
    let output = this.dateToMoment(); // today by default
    if (input) {
      output = this.dateToMoment(input);
      if (typeof input === 'string') {
        output = this.dateToMoment(input);

        if (input.includes('/')) {
          console.error('input string', input);
        }
      } else if (typeof input === 'number') {
        // timestamp
        output = this.dateToMoment(input);
      } else if (typeof input === 'object') {
        if (
          !moment.isMoment(input) &&
          !!input.year &&
          !!input.month &&
          !!input.day
        ) {
          // custom object
          const year = input.year;
          const month =
            Number(input.month) < 10
              ? '0' + Number(input.month)
              : Number(input.month);
          const day = input.day < 10 ? '0' + input.day : input.day;
          const str = year + '-' + month + '-' + day + ' 00:00:00';
          output = this.dateToMoment(str);
        } else {
          // date object
          output = this.dateToMoment(input);
        }
      }
    }
    if (!output.isValid()) {
      console.log('-------------------');
      console.error('dateToFormatFr input', input, typeof input);
      console.error(
        'dateToFormatFr output',
        output,
        output.toString(),
        output.isValid()
      );
      console.error('-------------------');
    }
    return output;
  }

  dateToMoment(input?: any) {
    const zone = 'Europe/Paris';
    moment.tz.setDefault(zone);
    moment.locale('fr');
    if (!!input) {
      return moment(input).tz(zone);
    }
    return moment().tz(zone);
  }

  addPromoIfExist(card) {
    if (card.offer_campaign.length > 0) {
      // DATE TO CHANGE
      const today = this.dateToFormatFr();
      // DATE TO CHANGE
      if (
        today >= this.dateToFormatFr(card.offer_campaign[0].starts_at) &&
        today <= this.dateToFormatFr(card.offer_campaign[0].ends_at)
      ) {
        card.promo = true;
        card.promoName = card.offer_campaign[0].name;
        // DATE TO CHANGE
        card.starts_at = this.dateToFormatFr(card.offer_campaign[0].starts_at);
        // DATE TO CHANGE
        card.ends_at = this.dateToFormatFr(card.offer_campaign[0].ends_at);
        card.amount =
          card.promo && card.discount > 0
            ? card.amount - card.discount + '€'
            : card.amount;
        card.price_desc =
          card.promo && card.discount > 0 ? card.amount + '€' : card.price_desc;
        card.badge =
          card.promo && card.discount > 0
            ? '-' + card.discount + '€'
            : card.badge;
        const nbDays = Math.ceil(
          (card.ends_at.valueOf() - today.valueOf()) / (1000 * 3600 * 24)
        );
        card.nbDaysLeft = 'Plus que ' + nbDays + ' jours pour en profiter';
      }
    }
  }

  buildOfferCards() {
    if (this.cardsDone) {
      return;
    }

    let manualDrivingOffers = {
      id: 'BVM',
      specialOffers: [],
      codeOffers: [],
      drivingOffers: [],
    };
    let automaticDrivingOffers = {
      id: 'BVA',
      specialOffers: [],
      codeOffers: [],
      drivingOffers: [],
    };

    for (const offer of this.studentCustomOffers) {
      // INITIALISE CARD DEFAULT VALUE OR SET THEM WITH THE OFFER
      let builtOfferCard = (({
        amount,
        description,
        discount,
        display_offer_type,
        displayable,
        id,
        key_points,
        max_quantity,
        min_quantity,
        name,
        offer_campaign,
        offer_credit_type,
        offer_type,
        price_desc,
        special_offer,
        text,
        title,
      }) => ({
        amount,
        badge: '',
        description,
        discount,
        display_offer_type,
        displayable,
        ends_at: '',
        forceWidth100: false,
        id,
        invert: false,
        key_points,
        link: 'payment',
        max_quantity,
        min_quantity,
        name,
        nbDaysLeft: '',
        offer_campaign,
        offer_credit_type,
        offer_type,
        price_desc,
        promo: false,
        promoName: '',
        special_offer,
        starts_at: '',
        text,
        title,
        transformed_amount: '',
        transformed_price_desc: '',
      }))(offer);

      if (!builtOfferCard.displayable) {
        continue;
      }

      this.addPromoIfExist(builtOfferCard);

      builtOfferCard.transformed_amount = this.setTransformedPrice(
        builtOfferCard.amount
      );
      builtOfferCard.transformed_price_desc = this.setTransformedPrice(
        builtOfferCard.price_desc
      );

      // SORT 'special_offer' OFFER IN THE RESPECTIVE SPECIAL OFFERS ARRAY FOR BVM AND BVA
      if (builtOfferCard.special_offer) {
        if (builtOfferCard.offer_credit_type === 'BVM') {
          manualDrivingOffers.specialOffers.push(builtOfferCard);
        }
        if (builtOfferCard.offer_credit_type === 'BVA') {
          automaticDrivingOffers.specialOffers.push(builtOfferCard);
        }
        continue;
      }
      // SORT OFFERS IN THE RIGHT CATEGORY ARRAY
      if (this.sortOfferCards(builtOfferCard, 'BVM', 'code')) {
        manualDrivingOffers.codeOffers.push(builtOfferCard);
        continue;
      }
      if (this.sortOfferCards(builtOfferCard, 'BVM', 'conduite')) {
        manualDrivingOffers.drivingOffers.push(builtOfferCard);
        continue;
      }
      if (this.sortOfferCards(builtOfferCard, 'BVA', 'code')) {
        automaticDrivingOffers.codeOffers.push(builtOfferCard);
        continue;
      }
      if (this.sortOfferCards(builtOfferCard, 'BVA', 'conduite')) {
        automaticDrivingOffers.drivingOffers.push(builtOfferCard);
        continue;
      }
    }

    this.builtOfferCards.push(manualDrivingOffers);
    this.builtOfferCards.push(automaticDrivingOffers);
    this.setOfferCardsOptions();
  }

  sortOfferCards(offer, offerCreditType, displayOfferType) {
    return (
      (offer.offer_credit_type === offerCreditType ||
        !offer.offer_credit_type) &&
      offer.display_offer_type === displayOfferType
    );
  }

  setOfferCardsOptions() {
    // ITERATE THROUGH BVM AND BVA
    for (const offerCreditType of this.builtOfferCards) {
      // ITERATE THROUGH OFFERS CATEGORIES (code, conduite, recommended, special)
      for (const displayOfferTypeKey of Object.keys(offerCreditType)) {
        if (displayOfferTypeKey === 'id') {
          continue;
        }
        // ITERATE THROUGH OFFERS
        for (const offer of offerCreditType[displayOfferTypeKey]) {
          if (offer.offer_type === 'code_exam') {
            offer.forceWidth100 = true;
            offer.link = 'reservation-examen-code';
          }
          if (offer.offer_type === 'big_pack') {
            offer.forceWidth100 = true;
            offer.link = 'packPermis';
          }
        }
      }
    }
    this.setLowestDrivingOfferPricePerHour();
    this.cardsDone = true;
  }

  setOffersDisplay(offersType, isModal = false) {
    if (offersType === this.switchOffers) {
      return;
    }

    if (isModal) {
      this.cleanMap();
    }

    this.switchOffers = offersType;
    this.offersService.gearType = offersType;
    this.storageService.set('gearType', offersType);
    this.setLowestDrivingOfferPricePerHour();

    if (
      !isModal &&
      this.switchOffers === 'BVA' &&
      !this.student?.near_bva_location &&
      !this.student.isGuest()
    ) {
      this.openModalMap();
    }
  }

  setLowestDrivingOfferPricePerHour() {
    const offersType = this.builtOfferCards.find(
      elt => elt.id === this.switchOffers
    );
    let lowestPrice = 0;
    for (const offer of offersType.drivingOffers) {
      const pricePerHour = offer.amount / offer.min_quantity;
      lowestPrice =
        lowestPrice === 0 || lowestPrice > pricePerHour
          ? pricePerHour
          : lowestPrice;
    }
    this.drivingSubTitle = `à partir de ${this.setTransformedPrice(lowestPrice)}`;
  }

  setTransformedPrice(price) {
    const numberedPrice = Number(price);

    if (numberedPrice === 0) {
      return null;
    }
    // TEXT
    if (Number.isNaN(numberedPrice)) {
      return price;
    }

    // INTEGER | STRING INTEGER
    if (Number.isInteger(numberedPrice)) {
      return `${numberedPrice.toString()}€`;
    }

    // FLOAT | STRING FLOAT
    return `${numberedPrice.toFixed(2).replace('.', ',')}€`;
  }

  callHideModalOfferNotFound(action?) {
    this.modalOfferNotFound.closeModal();
  }

  showModalOfferNotFound(action?) {
    this.displayModalOfferNotFound = true;
    this.modalShown = true;
  }

  hideModalOfferNotFound(action?) {
    this.addNewStyle(
      '.ion-page > ion-content > .scroll-content {overflow-y:auto !important;}'
    );
    this.displayModalOfferNotFound = false;
    this.modalShown = false;
  }

  hideModalEmbed() {
    this.showEmbedElt = false;
    this.embedSrc = null;
    this.modalShown = false;
  }

  showEmbed(url) {
    if (!this.networkStatusService?.isOffline()) {
      this.embedSrc = this.sanitizer.bypassSecurityTrustResourceUrl(url);
      this.showEmbedElt = true;
      this.modalShown = true;
    } else {
      this.navigationService.saveLinkToReload({ modalToOpenOnReload: url });
    }
  }

  addNewStyle(newStyle) {
    let styleElement = document.getElementById('styles_js');
    if (!styleElement) {
      styleElement = document.createElement('style');
      styleElement.setAttribute('type', 'text/css');
      styleElement.id = 'styles_js';
      document.getElementsByTagName('head')[0].appendChild(styleElement);
    }
    styleElement.appendChild(document.createTextNode(newStyle));
  }

  async openModalPack(
    bannerInfo?: any,
    type?: string,
    noClose = false,
    customClass = ''
  ) {
    // evs-global.scss : small-modal | medium-modal
    if (!type) {
      type = 'marketingRegular';
    }
    let props;
    if (bannerInfo) {
      props = {
        type: type,
        bannerInfo: {
          item_id: bannerInfo.itemId,
          item_promo_type: bannerInfo.itemPromoType,
          item_location_id: bannerInfo.itemLocationId,
          item_location_format: bannerInfo.itemLocationFormat,
          item_promo_content: bannerInfo.itemPromoContent,
        },
      };
    } else {
      props = {
        type: type,
        bannerInfo: null,
      };
    }
    let modal;
    if (noClose) {
      modal = await this.modalController.create({
        component: ModalMarketingComponent,
        backdropDismiss: false,
        cssClass: customClass,
        componentProps: props,
      });
    } else {
      modal = await this.modalController.create({
        component: ModalMarketingComponent,
        cssClass: customClass,
        componentProps: props,
      });
    }
    return await modal.present();
  }

  async openModalIframe(url: any, type?: string, noClose = true) {
    if (!type) {
      type = 'iframe';
    }
    let modal;
    if (noClose) {
      modal = await this.modalController.create({
        component: ModalIframeComponent,
        backdropDismiss: false,
        cssClass: 'custom-modal-iframe',
        componentProps: {
          type: type,
          url: url,
        },
      });
    } else {
      modal = await this.modalController.create({
        component: ModalIframeComponent,
        cssClass: 'custom-modal-iframe',
        componentProps: {
          type: type,
          url: url,
        },
      });
    }
    return await modal.present();
  }

  closeModals() {
    const modals = document.getElementsByTagName('ion-modal');
    while (modals.length > 0) {
      modals[0].parentNode.removeChild(modals[0]);
    }
  }

  async openLink(link, options?) {

    this.tunnelPaiementUrl = TunnelPaiementStepsEnum.TUNNEL;

    if (!!options && !!options.specialClicked && this.isDesktop) {
      return;
    }
    if (link === 'packPermis') {
      if (
        !this.student?.driving_department ||
        (!!this.student?.driving_department &&
          !this.student?.driving_department?.pricing_zone_id)
      ) {
        if (
          !!this.studentCustomOffers &&
          this.studentCustomOffers.length > 0 &&
          !this.fetchOffersFailed
        ) {
          const offersFound = this.studentCustomOffers.filter(
            elt =>
              elt.offer_type === 'big_pack' &&
              elt.offer_credit_type === this.switchOffers
          );
          const minOffer = offersFound.reduce(
            (prev, current) => (prev.amount < current.amount ? prev : current),
            0
          );
          if (minOffer) {
            let url = `${this.tunnelPaiementUrl}/${minOffer.offer_credit_type}/${minOffer.offer_type}/1/false`;
            if (
              minOffer?.title?.includes('sans code') &&
              url.endsWith('false')
            ) {
              url = url
                .replace('false', 'true')
                .replace('hour_pack', 'big_pack');
            }

            this.openLink(url);
          }
        }
      } else if (
        !!this.studentCustomOffers &&
        this.studentCustomOffers.length > 0 &&
        !this.fetchStudentCustomOffersFailed
      ) {
        const offersFound = this.studentCustomOffers.find(
          elt =>
            elt.offer_type === 'big_pack' &&
            elt.offer_credit_type === this.switchOffers
        );
        let url = `${this.tunnelPaiementUrl}/${offersFound.offer_credit_type}/${offersFound.offer_type}/1/false`;
        if (
          offersFound?.title?.includes('sans code') &&
          url.endsWith('false')
        ) {
          url = url.replace('false', 'true').replace('hour_pack', 'big_pack');
        }

        this.openLink(url);
      }
    } else if (link === 'payment') {
      if (!!options && !!options.offerId && !!options.offerType) {
        if (options.offerType === 'hour' || options.offerType === 'hour_pack') {
          if (!this.student.isGuest()) {
            this.statsService.send({ name: 'initiate_checkout:hours' });
          }

          if (
            !this.student?.driving_department ||
            (!!this.student?.driving_department &&
              !this.student?.driving_department?.pricing_zone_id)
          ) {
            if (
              !!this.studentCustomOffers &&
              this.studentCustomOffers.length > 0 &&
              !this.fetchOffersFailed
            ) {
              const offersFound = this.studentCustomOffers.filter(
                elt =>
                  elt.offer_type === options.offerType &&
                  elt.offer_credit_type === this.switchOffers &&
                  elt.min_quantity.toString() ===
                    options.offerMinQuantity.toString()
              );
              const minOffer = offersFound.reduce(
                (prev, current) =>
                  prev.amount < current.amount ? prev : current,
                0
              );
              if (minOffer) {
                let url = `${this.tunnelPaiementUrl}/${minOffer.offer_credit_type}/${minOffer.offer_type}/${minOffer.min_quantity}`;
                if (
                  minOffer?.title?.includes('sans code') &&
                  this.tunnelPaiementUrl === TunnelPaiementStepsEnum.TUNNEL
                ) {
                  url = url.replace(
                    `hour_pack/${minOffer.min_quantity}`,
                    'big_pack/1/true'
                  );
                }

                this.openLink(url);
              }
            }
          } else if (
            !!this.studentCustomOffers &&
            this.studentCustomOffers.length > 0 &&
            !this.fetchStudentCustomOffersFailed
          ) {
            const offersFound = this.studentCustomOffers.find(
              elt =>
                elt.offer_type === options.offerType &&
                elt.offer_credit_type === this.switchOffers &&
                elt.min_quantity.toString() ===
                  options.offerMinQuantity.toString()
            );
            let url = `${this.tunnelPaiementUrl}/${offersFound.offer_credit_type}/${offersFound.offer_type}`;
            if(offersFound.offer_type !== 'hour') {
              url += `/${offersFound.min_quantity}`;
            }
            if (
              offersFound?.title?.includes('sans code') &&
              this.tunnelPaiementUrl === TunnelPaiementStepsEnum.TUNNEL
            ) {
              url = url.replace(
                `hour_pack/${offersFound.min_quantity}`,
                'big_pack/1/true'
              );
            }

            this.openLink(url);
          }
        }

      } else {
        this.openLink('lecons-conduite');
        console.error(
          `Offres: ${(options.offerType || '') + (options.offerMinQuantity || '')} not found!`
        );
      }
    } else if (link === 'which-offer') {
      const tempUrl = 'https://www.youtube.com/embed/6pvHtQWX_Eo?autoplay=1';
      this.showEmbed(tempUrl);
    } else {
      const callbackUrl = await this.navigationService.open(link, options);
      if (!!callbackUrl && callbackUrl !== '') {
        this.openModalIframe(callbackUrl);
      }
    }
  }
}
